export default {"src":"/_next/static/media/files.7312dbb8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};